import { render, staticRenderFns } from "./Summation.vue?vue&type=template&id=edbd046e&"
import script from "./Summation.vue?vue&type=script&lang=js&"
export * from "./Summation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports